import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";

interface UnsavedChangesModalProps {
  open: boolean;
  onCancel: () => void;
  onSaveAndGo: () => void;
  isSubmitting: boolean;
}

function UnsavedChangesModal({
  open,
  onCancel,
  onSaveAndGo,
  isSubmitting,
}: UnsavedChangesModalProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Unsaved changes
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          You have unsaved changes in your profile. If you leave now, your
          updates will be lost.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          variant="outlined"
          className="px-6 py-2 rounded-full"
        >
          Cancel
        </Button>
        <Button
          onClick={onSaveAndGo}
          variant="contained"
          className="px-6 py-2 rounded-full"
          disabled={isSubmitting}
          startIcon={
            isSubmitting ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          {isSubmitting ? "Saving..." : "Save and go"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedChangesModal;
